import React, { useContext, useState, useEffect } from 'react';
import { MaterialsContext } from '../../../context/MaterialsContext';
import style from './style.module.scss';
import cn from 'classnames';
import { materials_tr } from '../../../lang/materials';

const lang = document.documentElement.lang;
const basePath = `/api/v1/${lang}/materiais`;

function Search() {
  const { originalData, setFilteredData, setShowHighlights, setFilter, setLoadMore } = useContext(MaterialsContext);
  const [search, setSearch] = useState('');

  useEffect(() => {
    async function loadData() {
      try {
        const res = await fetch(`${basePath}/?filter[keyword]=${search}`);
        const data = await res.json();

        setFilteredData(data.data);
      } catch (error) {
        console.log(error);
      }
    }

    let interval;
    if (search.length) {
      interval = setTimeout(() => {
        loadData();
        setShowHighlights(false);
        setLoadMore(false);
      }, 500);
    } else {
      setFilteredData(originalData);
      setShowHighlights(true);
      setLoadMore(true);
    }
    return () => clearTimeout(interval);
  }, [search]);

  return (
    <div className={style.search}>
      <div className={style.searchContainer}>
        <h3 className={style.title}>{materials_tr().searchbox.title}</h3>

        <input
          className={style.input}
          type="text"
          onChange={e => setSearch(e.target.value)}
          value={search}
          placeholder={materials_tr().searchbox.placeholder}
        />

        <button
          className={cn(style.button, { [style.buttonActive]: search })}
          onClick={e => setSearch('')}
        >
          {materials_tr().searchbox.button}
        </button>
      </div>

      <div className={style.filterWrapper}>
        <span onClick={e => setFilter(true)}>{materials_tr().searchbox.mobile_filter}</span>
      </div>
    </div>
  );
}

export default Search;
